<template>
  <div class="remote-control">
    <section class="equ-head">
      <div class="equipment">
        <!-- <div class="parallelogram">
          <span>远程控制</span>
        </div> -->
        <span class="title_bg">远程控制</span>
        <div class="equip-status">

          <span>{{switchData.name}}</span>
          <div :class="{'outline':switchData.powerStatus==0}">(
            <img
              class="equip-logo"
              :src="require('../../assets/images/Electric'+switchData.powerStatus+'.png')"
            >
            {{
              switchData.powerStatus!==0?"在线":"离线"
            }}
            )
          </div>
        </div>
      </div>
      <div
        class="warm"
        v-if="switchData.alarmMessageList.length&&second==0"
      ><i class="icon icon-icon_ann"></i>
        <span v-for="(m,num) in switchData.alarmMessageList" :key="num">
          {{m}}&nbsp;&nbsp;&nbsp;&nbsp;
        </span><i
          ref="input"
          id="Alarm"
          @click="clearAlame"
          class="icon icon-pop_icon_close"
        ></i> </div>
      <div class="setting">
        <span>全开</span>
        <el-switch
          style="display: block"
          :value="allOpen(switchData.switchs)"
          @change="changeAllSwitch(switchData,allOpen(switchData.switchs))"
          inactive-color="rgba(93,106,118,0.4)"
        >
        </el-switch>
        <i
          @click="toSetting(switchData)"
          class="icon icon-icon_set"
        ></i>
      </div>
    </section>
    <section class="equ-content">

      <div
        v-for="item in switchData.switchs"
        :key="item.id"
      >

        <p class="tips">
          {{item.alarmMessage}}
          <span v-if="item.limitCtrlTag" class="iconfont icondesc" :class="'associate'+item.limitCtrlTag%7" >&#xe603;</span>
          <span
            v-if="!item.limitCtrlTag"
            style="opacity:0"
          >0</span>
        </p>
        <div class="wrap-bg" @click="goDeviceEnergyHis(item)">
          <img :class="item.photo.length>100?'img4':'img'+item.photo" :src="item.photo.length>100?item.photo:require('../../assets/images/equipPhoto'+item.photo+'.png')">
          <div>
            <p>{{item.name}}</p>
            <p class="switch" @click.stop="">
                  <el-switch
                    style="display: block"
                    v-model="item.on"
                    @change="changeSwitch(switchData,item)"
                    inactive-color="rgba(93,106,118,0.4)"
                  >
                  </el-switch>
              <span>( {{judgeStatus(item.workMode)}} )</span>&nbsp; <span>{{item.on?'启动':'停止'}}</span>
            </p>
          </div>
        </div>
        <div class="power">
          <p>
            <span>额定电压：</span>
            <span>{{item.ratedVoltage}}&nbsp;V</span>
          </p>
          <p>
            <span>额定功率：</span>
            <span>{{item.ratedPower}}&nbsp;W</span>
          </p>
          <p>
            <span>当前电压：</span>
            <span>{{item.workingVoltage}}&nbsp;V</span>
          </p>
          <p>
            <span>当前功率：</span>
            <span>{{item.workingPower}}&nbsp;W</span>
          </p>
          <p>
            <span>开机时长：</span>
            <span>{{item.workingTimeDesc}}</span>
          </p>
        </div>
        <!--  v-if="(item.switchTimerCtrlList[0].startTime != '00:00' || item.switchTimerCtrlList[0].endTime != '00:00') || (item.switchTimerCtrlList[1].startTime != '00:00' || item.switchTimerCtrlList[1].endTime != '00:00')" -->
        <div class="timing">
          <p>定时开关</p>
          <div class="timing-wrap">
            <div
              v-for="(obj,index) in item.switchTimerCtrlList"
              class="timing-item"
              :key="index"
            >
              <span>{{obj.startTime}} - {{obj.endTime}}</span>
              <span @click="switchBtn(obj)" class="btn">{{obj.isEnable ==false?"已禁用":"已启用"}}</span>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import equipmentV2 from '../../store/modules/equipmentV2'
import mixins from '@/assets/js/mixins.js'
import { mapActions } from 'vuex'
export default {
  name: 'RemoteControl',
  mixins: [mixins],
  props: {
    switchData: {
      require: true
    }
  },
  data () {
    return {
      clearSecond: 1800, // 清除警报30分钟
      second: 0 // 清除警报
    }
  },
  watch: {},
  mounted () {},
  computed: {
    // 判断是否全选
    allOpen () {
      return function (data) {
        return data.every(item => {
          return item.on === true
        })
      }
    }
  },
  methods: {
    ...mapActions(equipmentV2, ['controlSwitch', 'controlAllSwitch', 'switchTimer']),
    toSetting (switchData) {
      this.$router.push({
        name: 'timeControl',
        query: {
          id: switchData.id,
          name: switchData.name
        }
      })
      console.log(787, switchData)
    },
    judgeStatus (status) {
      if (status === 1) {
        return '手动'
      } else if (status === 2) {
        return '远程'
      } else if (status === 3) {
        return '定时'
      }
    },
    async switchBtn (item) {
      try {
        let msg = item.isEnable ? '开关已禁用' : '开关已启用'
        await this.switchTimer({
          switchTimerId: item.switchTimerId,
          isEnable: !item.isEnable
        })
        item.isEnable = !item.isEnable
        this.$Alert.info({
          content: `${msg}`,
          duration: 1000,
          status: 'success'
        })
      } catch (err) {
        // let msg = item.isEnable?"启用失败":"禁用失败"
        this.$Alert.info({
          content: err.response.data,
          duration: 3000,
          status: 'error'
        })
      }
    },
    // 清除警报
    clearAlame () {
      this.second = this.clearSecond
      let timer = setInterval(() => {
        --this.second
        if (this.second <= 0) {
          this.second = 0
          clearInterval(timer)
        }
      }, 1000)
      // 清除警报声音
      this.$emit('clearAlame')
    },
    updateData () {
      let obj = JSON.parse(localStorage.getItem('currentBasic'))
      this.getEquipmentData(obj, false).then(() => {

      }).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 3000,
          status: 'error'
        })
      })
    },
    changeAllSwitch (data, bool) {
      // 远程控制开关
      this.controlAllSwitch({ id: data.id, switchEnum: !bool ? 1 : 0 })
        .then(result => {
          // this.$message({
          //   type: 'success',
          //   message: 'chengogng'
          // })
          data.switchs.forEach((item) => {
            item.on = !bool
          })
          // this.updateData()
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
          // this.updateData()
        })
    },
    changeSwitch (data, item) {
      // 远程控制开关
      this.controlSwitch({
        id: data.id,
        iotName: item.iotName,
        switchEnum: !item.on ? 0 : 1
      })
        .then(result => {
          // this.$message({
          //   type: 'success',
          //   message: 'chengogng'
          // })
          if (!result) {
            this.updateData()
          }
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
          this.updateData()
        })
    },
    // 进入电量分析
    goDeviceEnergyHis (item) {
      console.log(555, item)
      this.$router.push({
        name: 'deviceEnergyHis',
        query: {
          id: item.id,
          iotName: item.iotName,
          equName: this.switchData.name,
          equId: this.switchData.id
        }
      })
    }
  }
}
</script>
<style lang="scss">
.remote-control {
  margin-top: 0.2rem;
  .el-switch,
  .el-switch__core {
    width: 0.66rem !important;
    height: 0.34rem;
    border-radius: 0.2rem;
  }
  .el-switch__core:after {
    width: 0.3rem;
    height: 0.3rem;
    background-color: #fff;
  }
  .el-switch.is-checked .el-switch__core::after {
    left: 100%;
    margin-left: -0.28rem;
  }
  .equ-head {
    position: relative;
    margin: 0 0.25rem;
    height: 0.45rem;
    border-bottom: 1px solid #148eff;
    line-height: 0.44rem;
    text-align: center;
    .title_bg{
      display: inline-block;
      width: 1.45rem;
      height: 0.45rem;
      margin-right: 0.1rem;
      padding-right: 0.06rem;
      font-size: 0.18rem;
      color:#FEFEFE;
      background: url('../../assets/images/title_bg_2.png') no-repeat;
      background-size: 100% 100%;
    }
    .equipment {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-self: center;
    }
    .equip-status {
      display: flex;
      align-items: center;
      font-size: 0.16rem;
      span {
        margin-right: 0.08rem;
      }
      .outline {
        color: #707a97;
      }
    }
    .warm {
      display: inline-block;
      padding: 0 0.2rem;
      border-radius: 4px;
      line-height: 0.3rem;
      height: 0.3rem;
      background: #562a31;
      .icon-icon_ann {
        margin-right: 0.15rem;
      }
      .icon-pop_icon_close {
        // margin-left: 5px;
        cursor: pointer;
      }
    }
    .setting {
      width: 1.6rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      right: 0;
      top: 0;
      span {
        font-size: 0.14rem;
      }
      .icon-icon_set {
        cursor: pointer;
      }
    }
  }
  .equ-content {
    padding: 0 0.25rem;
    display: flex;
    flex-wrap: wrap;
    // align-items: baseline;
    .associate {
      width: 0.34rem;
      height: 0.15rem;
    }
    .icondesc{
      font-size: 0.38rem;
      margin-top: -0.22rem;
    }
    .associate0{
      color: #2ed7e3;
    }
    .associate1{
      color: #e3822e;
    }
    .associate2{
      color: #e0e32e;
    }
    .associate3{
      color: #2ee35d;
    }
    .associate4{
      color: #2ee3a0;
    }
    .associate5{
      color: #884cca;
    }
    .associate6{
      color: #3c7bd9;
    }
    > div {
      width: 3.88rem;
      height: auto;
      margin-right: 0.74rem;
      margin-top: 0.2rem;
      padding: 0 0.27rem 0.3rem;
      font-size: 0.18rem;
      // background: url("../../assets/images/yuanchengkongzhi__kuang.png")
      //   no-repeat;
      background: url("../../assets/images/list_jidi_kuang_shang.png") no-repeat top center, url("../../assets/images/list_jidi_kuang_xia.png") no-repeat bottom center;
      background-size: contain;
      position: relative;
      &::after {
        content: '';
        width: 0.02rem;
        background: rgba(50, 214, 226, 1);
        height: calc(100% - 1.36rem);
        position: absolute;
        left: 0;
        top: 1.32rem;
      }
      &::before {
        content: '';
        width: 2px;
        background: rgba(50, 214, 226, 1);
        height: calc(100% - 1.36rem);
        position: absolute;
        right: 0;
        top: 1.32rem;
      }
    }
    .tips {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.18rem;
      color: #f52525;
      line-height: 0.5rem;
      height: 0.5rem;
      float: right;
    }
    .wrap-bg {
      display: flex;
      align-items: center;
      width: 3.34rem;
      height: 1.14rem;
      margin-top: 0.15rem;
      background: url("../../assets/images/home_icon_bg.png") no-repeat;
      background-size: 100% 100%;
      > div {
        margin-left: 0.3rem;
        display: flex;
        flex-direction: column;
      }
      img {
        margin-left: 0.2rem;
      }
      .img1{
        margin-right: 0.05rem;
        width: 0.74rem;
        height: 0.72rem;
      }
      .img2{
        margin-left: 0.24rem;
        margin-top: -1px;
        margin-right: 0.1rem;
        width: 0.65rem;
        height: 0.65rem;
      }
      .img3{
        width: 0.81rem;
        height: 0.68rem;
      }
      .img4{
        margin-left: 0.23rem;
        margin-right: 0.1rem;
        width: 0.68rem;
        height: 0.68rem;
        border-radius: 4px;
        overflow: hidden;
      }
      .switch {
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        height: 0.66rem;
      }
      .el-switch {
        margin-right: 0.15rem;
      }
    }
    .power {
      display: flex;
      flex-wrap: wrap;
      margin-top: 0.3rem;

      color: #fff;
      > p {
        display: flex;
        flex: 0 0 50%;
        align-items: center;
        line-height: 0.3rem;
        &:nth-child(5) {
          flex: 0 0 100%;
        }
        span{
          &:nth-child(1){
            margin-right: 0.1rem;
            font-size: 0.14rem;
            color: #BBD4E9;
          }
          &:nth-child(2){
            font-size: 0.18rem;
            color: #fff;
          }
        }
      }
    }
    .timing {
      margin-top: 0.2rem;
      p {
        line-height: 0.35rem;
        font-size: 0.16rem;
        color: #8b919f;
      }
      .timing-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .timing-item {
          line-height: 0.45rem;
          width: 50%;
          display: flex;
          align-items: center;
          font-size: 0.14rem;
        }
      }
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 0.05rem;
        .btn {
          // width: 74px;
          padding: 0 0.06rem;
          margin-left: 0.1rem;
          border: 1px solid #3c7bd9;
          border-radius: 0.04rem;
          text-align: center;
          line-height: 0.32rem;
          cursor: pointer;
        }
      }
    }
  }
  // @media screen and (max-width: 1433px) {
  //   .el-switch.is-checked .el-switch__core::after {
  //     left: 100%;
  //     margin-left: -0.2rem;
  //   }
  //   .icon-icon_set{
  //      transform: scale(0.8);
  //   }
  //   .equ-head{
  //     height: 0.36rem;
  //     line-height: 0.36rem;
  //     .title_bg{
  //       display: inline-block;
  //       width: 1.2rem;
  //       height: 0.36rem;
  //       margin-right: 0.1rem;
  //       padding-right: 0.06rem;
  //       font-size: 0.16rem;
  //       color:#FEFEFE;
  //       background: url('../../assets/images/title_bg_2.png') no-repeat;
  //       background-size:100% 100%;
  //     }
  //     .equip-status {
  //       font-size: 0.14rem;
  //       img{
  //         height: 0.24rem
  //       }
  //     }
  //     .warm {
  //       display: inline-block;
  //       padding: 0 0.2rem;
  //       border-radius: 0.04rem;
  //       line-height: 0.26rem;
  //       height: 0.26rem;
  //       background: #562a31;
  //       .icon-icon_ann {
  //         margin-right: 0.15rem;
  //       }
  //       .icon-pop_icon_close {
  //         cursor: pointer;
  //       }
  //     }
  //     .el-switch,
  //     .el-switch__core {
  //       width: 0.5rem !important;
  //       height: 0.24rem;
  //       border-radius: 0.2rem;
  //     }
  //     .el-switch__core:after {
  //       width: 0.2rem;
  //       height: 0.2rem;
  //       background-color: #fff;
  //     }
  //     .setting {
  //       width: 1.35rem;
  //       display: flex;
  //       align-items: center;
  //       justify-content: space-between;
  //       position: absolute;
  //       right: 0;
  //       top: 0;
  //       .icon-icon_set {
  //         cursor: pointer;
  //       }
  //     }
  //   }
  //   .equ-content {
  //     .icondesc {
  //       font-size: 0.3rem;
  //       margin-top: -0.18rem;
  //     }
  //     > div {
  //       width: 2.85rem;
  //       height: 3.25rem;
  //       margin-right: 0.35rem;
  //       margin-top: 0.2rem;
  //       padding: 0 0.08rem 0 0.2rem;
  //       font-size: 0.18rem;
  //       background-size: 100% 100%;
  //       .tips {
  //         display: flex;
  //         justify-content: space-between;
  //         align-items: center;
  //         font-size: 0.18rem;
  //         color: #f52525;
  //         line-height: 0.35rem;
  //         height: 0.35rem;
  //         float: right;
  //         padding:0 0.1rem 0 0;
  //       }
  //       &:last-child{
  //         margin-right:0;
  //       }
  //     }
  //     .wrap-bg {
  //       width: 2.42rem;
  //       height: 0.8rem;
  //       font-size:0.14rem;
  //        > div {
  //         margin-left: 0.15rem;
  //       }
  //       img {
  //         margin-left: 0px;
  //         transform: scale(0.7)
  //       }
  //       .img1{
  //         margin-right: 0.05rem;
  //         margin-left:0.04rem;
  //         width: 0.74rem;
  //         height: 0.72rem;
  //       }
  //       .img2{
  //         margin-left: 0.09rem;
  //         margin-top: -1px;
  //         margin-right: 0.1rem;
  //         width: 0.65rem;
  //         height: 0.65rem;
  //       }
  //       .img3{
  //         margin-left:0.04rem;
  //         width: 0.76rem;
  //         height: 0.64rem;
  //       }
  //       .img4{
  //         margin-left: 0.08rem;
  //         margin-right: 0.1rem;
  //         width: 0.68rem;
  //         height: 0.68rem;
  //         border-radius: 0.04rem;
  //         overflow: hidden;
  //       }
  //       .switch {
  //         display: flex;
  //         align-items: center;
  //         font-size: 0.12rem;
  //         height: 0.44rem;

  //       }
  //       .el-switch,
  //       .el-switch__core {
  //         width: 0.5rem !important;
  //         height: 0.24rem;
  //         border-radius: 0.2rem;
  //       }
  //       .el-switch__core:after {
  //         width: 0.2rem;
  //         height: 0.2rem;
  //         background-color: #fff;
  //       }
  //     }
  //     .power{
  //       margin-top:0.15rem;
  //       > p {
  //         display: flex;
  //         flex: 0 0 50%;
  //         align-items: center;
  //         line-height: 0.24rem;
  //         font-size: 0.12rem;
  //         span{
  //           &:nth-child(1){
  //             margin-right: 0px;
  //             font-size: 0.12rem;
  //             color: #BBD4E9;
  //           }
  //           &:nth-child(2){
  //             font-size: 0.16rem;
  //             color: #fff;
  //           }
  //         }
  //       }
  //     }
  //     .timing{
  //       margin-top: 0.1rem;
  //       p {
  //         line-height: 0.28rem;
  //         font-size: 0.14rem;
  //         color: #8b919f;
  //       }
  //       > div {
  //         display: flex;
  //         align-items: center;
  //         justify-content: space-between;
  //         margin-top: 0.05rem;
  //         padding-right: 0.2rem;
  //         font-size: 0.14rem;

  //         .btn {
  //           width: 0.62rem;
  //           border: 1px solid #3c7bd9;
  //           border-radius: 0.04rem;
  //           text-align: center;
  //           line-height: 0.24rem;
  //           cursor: pointer;
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>
